import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import getStateManager from '../StateManager.js';

export function TabInfo({ className, zone_id, tab_id, controller }) {
  const { t } = useTranslation();
  const stateManager = getStateManager();

  // Get the actual zone name if zone_id is provided and controller exists
  let zoneName = undefined;
  if (zone_id && controller) {
    const parent = stateManager.getParent(controller, zone_id);
    if (parent && parent.name !== undefined) {
      zoneName = parent.name;
    }
  }

  const displayText = [zoneName !== undefined && zoneName, tab_id !== undefined && t(tab_id)]
    .filter(Boolean)
    .join(' • ');

  return <Typography className={className}>{displayText || null}</Typography>;
}
